export enum THEMES {
  DEFAULT = 'default',
  RDK = 'rdk',
}

export type ThemesType = `${THEMES}`
